export default "__VITE_ASSET__84ff843e__"